import React from 'react';
import { useFormContext } from 'react-hook-form';
import Grid from '@material-ui/core/Grid';
import { EmailRemindersFields, InterviewSchedule } from 'features/sendouts/components/forms';
import strings from 'strings';
import { When } from 'UI/components/atoms';
import NumberedForm from 'UI/components/molecules/NumberedForm';

import { FORM_FIELDS_MAP } from '../../CreateSendoutDrawer/SendoutForm/SendoutForm.constants';
import { NumberedFormWrapper } from '../CreateSendoutInterviewDrawer.styled';

import { OtherInterviewerFields } from './OtherInterviewerFields';

const { sections: STRINGS } = strings.sendoutsV2.form;

export const CreateSendoutInterviewForm = ({ candidateName, hiringAuthorityName }) => {
  const { watch } = useFormContext();
  const formValues = watch([
    FORM_FIELDS_MAP.InterviewDate.key,
    FORM_FIELDS_MAP.InterviewTimeFrame.key,
    FORM_FIELDS_MAP.InterviewFromHour.key,
    FORM_FIELDS_MAP.InterviewTimezone.key,
    FORM_FIELDS_MAP.InterviewLink.key
  ]);

  const interviewTime = formValues[FORM_FIELDS_MAP.InterviewFromHour.key];
  const shouldDisplayReminders =
    !!formValues[FORM_FIELDS_MAP.InterviewTimeFrame.key] &&
    !!interviewTime &&
    !!formValues[FORM_FIELDS_MAP.InterviewTimezone.key] &&
    !!formValues[FORM_FIELDS_MAP.InterviewDate.key];

  return (
    <Grid container>
      <NumberedFormWrapper item xs={12}>
        <NumberedForm>
          <NumberedForm.Item title={STRINGS.interviewDetails.title}>
            <InterviewSchedule />
          </NumberedForm.Item>
          <When condition={shouldDisplayReminders}>
            <NumberedForm.Item title={STRINGS.emailReminders.title}>
              <EmailRemindersFields
                candidateName={candidateName}
                hiringAuthorityName={hiringAuthorityName}
                url={formValues[FORM_FIELDS_MAP.InterviewLink.key]}
              />
            </NumberedForm.Item>
            <NumberedForm.Item title={STRINGS.otherInterviewer.title}>
              <OtherInterviewerFields />
            </NumberedForm.Item>
          </When>
        </NumberedForm>
      </NumberedFormWrapper>
    </Grid>
  );
};
